import { apiPrefix, ConnectionService } from './Connecion.service';

// Const
// import nuclias from '../const/nuclias';

const RESOURCE = 'auth';

class AuthService extends ConnectionService {
  constructor() {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async getUser() {
    const url = `${this.basedUrl}/User`;
    return super.sendRequest(url, {}, true);
  }

  async getAuthResources() {
    const url = `${this.basedUrl}/resources`;
    return super.sendRequest(url, {}, true);
  }
}

export default new AuthService();
